import { useTranslation } from 'react-i18next'

import Text from '../../../Text'
import {
  CALENDAR_SETTINGS_FIELD_NAME_SENDER_MAIL_ACCOUNT,
  QA_NAME_CALENDAR_SETTINGS_SENDER_DEAD_REFERENCE,
  QA_NAME_CALENDAR_SETTINGS_SENDER_EMPTY,
} from '../../CalendarSettings.constants'
import {
  getCalendarSettingsSenderOptions,
  isCalendarSettingsSenderListEmpty,
} from '../../CalendarSettings.utils'
import { CalendarSettingsSelectField } from '../CalendarSettingsSelectField'

import * as styles from './SenderMailboxField.module.css'

function SenderMailboxField({ deadReference, options }) {
  const { t } = useTranslation()

  const isListEmpty = isCalendarSettingsSenderListEmpty(options)

  return (
    <div className={styles.SenderMailboxField}>
      <CalendarSettingsSelectField
        disabled={isListEmpty}
        labelKey='CalendarSettings.SenderMailboxKey'
        name={CALENDAR_SETTINGS_FIELD_NAME_SENDER_MAIL_ACCOUNT}
        options={getCalendarSettingsSenderOptions({ options, t })}
      />
      {deadReference ? (
        <Text
          isSecondary
          className={styles.line}
          qaName={QA_NAME_CALENDAR_SETTINGS_SENDER_DEAD_REFERENCE}
        >
          {t('CalendarSettings.SenderMailboxDeadKey', {
            email: deadReference.email,
          })}
        </Text>
      ) : null}
      {isListEmpty ? (
        <Text
          isSecondary
          className={styles.line}
          qaName={QA_NAME_CALENDAR_SETTINGS_SENDER_EMPTY}
        >
          {t('CalendarSettings.SenderMailboxEmptyKey')}
        </Text>
      ) : null}
    </div>
  )
}

export default SenderMailboxField
